import { render, staticRenderFns } from "./AddHostingBasicInfo.vue?vue&type=template&id=6f145ad0"
import script from "./AddHostingBasicInfo.vue?vue&type=script&lang=js"
export * from "./AddHostingBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports